import request from '@/utils/request'

let Requirement_typeApi = {

  /*需求类型列表*/
  list(data) {
    return request._post('/shop/plus.requirement_type.Index/index', data);
},
/*添加需求类型*/
add(data) {
    return request._post('/shop/plus.requirement_type.Index/add', data);
},
/*修改需求类型*/
edit(data) {
    return request._post('/shop/plus.requirement_type.Index/edit', data);
},
/*删除需求类型*/
del(data) {
    return request._post('/shop/plus.requirement_type.Index/del', data);
},
/*需求类型详情*/
detail(data) {
  return request._post('/shop/plus.requirement_type.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.requirement_type.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.requirement_type.Setting/getSetting', data, errorback);
    },
}
export default Requirement_typeApi;



// WEBPACK FOOTER //
// ./src/api/requirement_type.js